import React from 'react';
import BlockSortSettings from '../../../../../Components/Admin/Pages/Blocks/BlockSortSettings';
import { BlockFormState } from '../../types';

interface SortTabProps {
    kedo: any;
    state: BlockFormState;
    handleChangeSettings: (key: string, val: any) => void;
}

const SortTab: React.FC<SortTabProps> = ({
    kedo,
    state,
    handleChangeSettings,
}) => {
    if (state.item.type !== 'dashboard') return null;

    return (
        <BlockSortSettings
            sort={state.item.settings.sort}
            viewName={state.item.settings.view_name}
            defDossierId={state.item.defDossier}
            kedo={kedo}
            onChangeSort={(sortSettings: any) => handleChangeSettings('sort', sortSettings)}
        />
    );
};

export default SortTab;